<mat-toolbar color="primary" class="toolbar">
    <app-back-button [route]="['/home', 'perfil']" color="secondary"></app-back-button>
    <div>{{ "CERTIFICATES.TITLE" | translate }}</div>
</mat-toolbar>

<div class="content">
    <ngx-spinner [fullScreen]="false" bdColor="rgba(0,0,0,0.2)" type="ball-spin" size="default"> </ngx-spinner>
    <mat-table [dataSource]="data" class="mat-elevation-z8">
        <ng-container matColumnDef="certificate">
            <mat-header-cell *matHeaderCellDef> {{ "CERTIFICATES.CERTIFICATE" | translate }} </mat-header-cell>
            <mat-cell *matCellDef="let element" (click)="open(element.id)" class="cursor-pointer">
                {{ element.course?.titulo }}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="date">
            <mat-header-cell *matHeaderCellDef class="data"> {{ "CERTIFICATES.DATE" | translate }} </mat-header-cell>
            <mat-cell *matCellDef="let element" (click)="open(element.id)" class="data cursor-pointer">
                {{ element.createdAt | date: "dd/MM/yyyy HH:mm" }}
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="['certificate', 'date']"></mat-header-row>
        <mat-row *matRowDef="let row; columns: ['certificate', 'date']"></mat-row>
    </mat-table>

    <div fxLayout="row" fxLayoutAlign="center center" style="margin-top: 15px">
        <button mat-raised-button color="primary" (click)="loadMore()" *ngIf="datas.data.length < datas.totalRows">
            {{ "CERTIFICATES.LOAD_MORE" | translate }}
        </button>
    </div>
</div>
